var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGlassware = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 3.523c-3.3.259-6.246.472-6.547.474-.301.002-.589.025-.64.052-.051.028-2.685.245-5.853.484-3.168.239-5.886.448-6.04.465l-.28.03v21.944l.28.03c.154.017 2.872.226 6.04.465 3.168.239 5.802.456 5.853.484.051.027.305.049.564.049.26 0 3.276.216 6.703.48 3.427.264 6.287.48 6.355.48h.125V3.04l-.28.006c-.154.004-2.98.218-6.28.477m5.12 6.397v5.333H16.747v-4.906c0-2.699.006-4.909.013-4.911.012-.004 10.418-.826 10.667-.843.088-.006.093.281.093 5.327m-12.267.48v4.853H4.48v-4.428c0-3.495.014-4.433.067-4.45.067-.023 10.139-.81 10.506-.822l.2-.006V10.4m0 11.207v4.861l-.333-.032c-.183-.017-2.577-.202-5.32-.41-2.743-.209-5.017-.389-5.053-.401-.053-.017-.067-.955-.067-4.45v-4.428h10.773v4.86m12.267.476v5.337l-.227-.03a628.96 628.96 0 0 0-5.213-.405 498.811 498.811 0 0 1-5.16-.402l-.173-.028v-9.808H27.52v5.336",
    fillRule: "evenodd",
    fill: "#000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGlassware, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/glassware.0d3e1fc6.svg";
export { ForwardRef as ReactComponent };